import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const Checksession = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (token) {
      const queryParams = new URLSearchParams(location.search);

      // session_id already exists, don't add again
      if (!queryParams.has('session_id')) {
        const sessionId = Math.floor(
          100000000 + Math.random() * 900000000
        );

        queryParams.set('session_id', sessionId);

        navigate(
          `${location.pathname}?${queryParams.toString()}`,
          { replace: true }
        );
      }
    }
  }, [token, location.pathname, location.search, navigate]);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default Checksession;